import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../../lib/api";
import "./halloween.css";

const DEFAULTS = { halloween_enabled: false, banner_text: "" };
const HalloweenContext = createContext({ ...DEFAULTS, enabled: false, loaded: false, save: async () => {} });

export function HalloweenProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/settings/theme")
      .then(({ data }) => setSettings({ ...DEFAULTS, ...data }))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const enabled = Boolean(settings.halloween_enabled);

  useEffect(() => {
    document.documentElement.classList.toggle("theme-halloween", enabled);
    return () => document.documentElement.classList.remove("theme-halloween");
  }, [enabled]);

  const save = useCallback(async (partial) => {
    const { data } = await api.put("/admin/settings/theme", { ...settings, ...partial });
    setSettings({ ...DEFAULTS, ...data });
  }, [settings]);

  return (
    <HalloweenContext.Provider value={{ ...settings, enabled, loaded, save }}>
      {children}
    </HalloweenContext.Provider>
  );
}

export const useHalloween = () => useContext(HalloweenContext);
